import { Injectable } from '@angular/core';
import { isNumber } from 'lodash';

@Injectable()
export class GeolocationDataBuilder {
  constructor() {}

  buildGoogleMapsUrl(latitude: number, longitude: number) {
    return isNumber(latitude) && isNumber(longitude)
      ? `https://maps.google.com/?q=${latitude},${longitude}`
      : null;
  }
}
